export default "__VITE_ASSET__DWXZV_t$__"